import React from "react";
import {map,get} from "lodash";
import { format } from "date-fns";

import filterCredits from "~/tools/filterCreditBlocks";
import { trackEvent, setPlaySourcePrefix } from "~/tools/analytics/cleverTap";
import formatVideoDuration from "~/tools/formatVidDuration";
import { ellipsifyByChar } from "~/tools/strings/ellipsify";
import SharePopup from "~/views/Share/events";
import PersonItem from "~/components/PersonItem";

import { getUser } from "~/redux/user/helpers";
import {
  getVideoInfo,
  addToQueue,
  removeFromQueue
} from "~/redux/uservideo/helpers";
import Badge from "~/elements/Tray/Badge";
import {getThumbnailImage, getLowQualityImage} from "./helpers";

import { getLocalizedVal } from '~/tools/localization/helpers'

import WatchlistBtn from "~/elements/watchlistBtn";

import Cookies from 'js-cookie'

class TrayItem extends React.Component {
  constructor(props)
  {
    super(props);
    this.el = React.createRef();
  }
  state = {
    hoverOverflow: false,
    isFocused: false
  };

  // get badge() {
  //   let dimensions = this.props.thumbnailType === "portrait" ? "_3x4" : "_16x9";
  //   let badge = get(this.props.item, `gist.badgeImages["${dimensions}"]`);
  //   if (badge)
  //     return (
  //       <img alt="badge" src={badge} className="badge" role="presentation" />
  //     );
  // }

  get metaData() {
    const gist = get(this.props, "item.gist");
    const metaData = get(window.settings, "brand.metadata");
    if (!gist) return;

    return (
      <div className="metadata">
        {metaData && metaData.displayDuration && gist.runtime > 0 && (
          <span>{formatVideoDuration(gist.runtime)}</span>
        )}
        {metaData && metaData.displayAuthor && gist.author && (
          <span>{gist.author}</span>
        )}
        {metaData && metaData.displayPublishDate && gist.publishDate && (
          <span>{format(gist.publishDate, "MMM D")}</span>
        )}
        {gist.contentType === "IMAGE" &&
          this.props.item.streamingInfo &&
          this.props.item.streamingInfo.photogalleryAssets.length > 0 && (
            <span>
              <ion className="ion-camera" />{" "}
              {this.props.item.streamingInfo.photogalleryAssets.length} Photos
            </span>
          )}
      </div>
    );
  }

  handleHover = () => {
    const el = this.el.current;
    if(el)
    {
      var bb = el.getBoundingClientRect();
      var cw = window.document.body.clientWidth;
      this.setState({ hoverOverflow: cw < bb.right + bb.width });
      setTimeout(_ => this.fetchUserData(), 0);
    }
  };

  handleClick = event => {
    const { trayTitle, index, season, item } = this.props || {};
    if (trayTitle) setPlaySourcePrefix(trayTitle);
    //Need to check if Item from Recommendation Tray is Clicked
    Cookies.set('isFromRecommendationTray' , false);
    if(this.props.trayTitle==="recommdationTray"){
      Cookies.set('isFromRecommendationTray' , true);
    }
    this.props.isEpisode
      ? this.props.openEpisodeOverlay(event, index, season, item)
      : this.clearSession();
  };

  handleBundleClick = event => {
    if(this.props.isBundle) this.props.purchaseBundleItem(event, this.props.item)
  }

  // TODO: gotta figure out what the code below does
  // items should also be highlighted when navigating with keyboard only

  // handleFocus = e => {
  //   setTimeout(() => {
  //     if(this.el.current){
  //       this.el.current.focus();
  //     }
  //     this.props.onFocus(this.props.index);
  //   }, 500);
  // };

  handleShareToggleClick = event => {
    event.preventDefault();
    const shareOptions = {
      position: event.currentTarget.getBoundingClientRect(),
      data: this.props.item.gist
    };
    SharePopup.open(shareOptions);
  };

  clearSession() {
    //clearing the session for the autoplay to reinitiate to new set of videos
    window.sessionStorage.removeItem("rvid");
  }

  fetchUserData() {
    var id = this.props.item.gist.id;
    getUser(user => {
      if (!user) {
        this.setState({ userData: null });
        return;
      }
      getVideoInfo(id, data => {
        this.setState({ userData: data });
      });
    });
  }

  addToQueue = () => {
    const { gist = {}, creditBlocks = [], categories = [] } = this.props.item;
    const id = gist.id;
    const contentType = gist.contentType;

    addToQueue(id, contentType, data => {
      categories.push(gist.primaryCategory);
      var addToQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.mediaType === "EPISODIC" ? "Episode" : "Video",
        contentDuration: gist.runtime,
        playbackType: "Streamed",
        networkType : window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi",
				platform: "Web",
				playSource: window.sessionStorage.getItem('playSourcePrefix') || '',
				showName: gist.title,
      };
      creditBlocks.forEach(creditBlock => {
        if (creditBlock.title.trim().toLowerCase() === "director") {
          addToQueueEventData.directorName =
            creditBlock.credits && creditBlock.credits.length > 0
              ? creditBlock.credits.map(it => it.title).join(",")
              : "";
        }
        if (creditBlock.title.trim().toLowerCase() === "starring") {
          addToQueueEventData.actorName =
            creditBlock.credits && creditBlock.credits.length > 0
              ? creditBlock.credits.map(it => it.title).join(",")
              : "";
        }
      });
      addToQueueEventData.contentGenre = categories
        .map(category => category.title)
        .join(",");
      trackEvent("Added to Watchlist", addToQueueEventData);
      this.setState({ isQueued: true });
    });
  };

  removeFromQueue = () => {
    const { gist = {}, creditBlocks = [], categories = [] } = this.props.item;
    const id = gist.id;

    removeFromQueue(id, data => {
      categories.push(gist.primaryCategory);
      var removeFromQueueEventData = {
        contentId: gist.id,
        contentTitle: gist.title,
        contentType: gist.mediaType === "EPISODIC" ? "Episode" : "Video",
        contentDuration: gist.runtime,
        playbackType: "Streamed",
        networkType : window.navigator.connection ? (window.navigator.connection.type ? window.navigator.connection.type : window.navigator.connection.effectiveType) : "wifi",
				platform: "Web",
				playSource: window.sessionStorage.getItem('playSourcePrefix') || '',
				showName: gist.title,
      };
      creditBlocks.forEach(creditBlock => {
        if (creditBlock.title.trim().toLowerCase() === "director") {
          removeFromQueueEventData.directorName =
            creditBlock.credits && creditBlock.credits.length > 0
              ? creditBlock.credits.map(it => it.title).join(",")
              : "";
        }
        if (creditBlock.title.trim().toLowerCase() === "starring") {
          removeFromQueueEventData.actorName =
            creditBlock.credits && creditBlock.credits.length > 0
              ? creditBlock.credits.map(it => it.title).join(",")
              : "";
        }
      });
      removeFromQueueEventData.contentGenre = categories
        .map(category => category.title)
        .join(",");
      trackEvent("Removed From Watchlist", removeFromQueueEventData);
      this.setState({ isQueued: false });
    });
  };

  showTitle = (gist) => {
    let title = gist.title;
    if(gist.contentType && gist.contentType.toLowerCase() == 'person') {
      if(gist.firstName && gist.lastName) {
        title = `${gist.firstName} ${gist.lastName}`;
      } else if(gist.firstName) {
        title = gist.firstName;
      } else if(gist.lastName) {
        title = gist.lastName;
      }
    }
    return title;
  }

  get trayHoverStyle(){
    return {
      boxShadow: `0px 0px 34px 0px ${get(window.settings, 'brand.trayGlow.trayGlowColor')}`
    }
  }

  render() {
    let { item, index } = this.props;
    let gist = item.gist || {};
    let creditBlocks = item.creditBlocks || (gist && gist.creditBlocks) || null;
    let filteredCreditBlocks = creditBlocks && filterCredits(creditBlocks);
    const isSeasonPurchasable = get(this.props, 'refItems[0].contentType', '');
    const isTrayGlow = get(window.settings, 'brand.trayGlow.isTrayGlow')

    if (!(isSeasonPurchasable === "SEASON_PASS")) index++

    const isEpisodePurchasable =
      !gist.free &&
      (item.pricing && item.pricing.purchase !== null) &&
      item.purchaseStatus !== "PURCHASED" && this.props.isEpisode;

    const isBundlePurchasable =
      !gist.free &&
      (item.pricing && item.pricing.purchase !== null) &&
      item.purchaseStatus !== "PURCHASED" && this.props.isBundle && !this.props.bundlePurchased;

    if (item.contentType === "PERSON") {
      return <PersonItem item={item} thumbnail={item.gist.imageGist._3x4} displayTitle="true" />;
    } else if (item.contentType === "SEASON_PASS") {
      return (
        <a className="video-tray-item" onClick={this.handleClick}>
          <div
            className="image-and-details"
            style={{ backgroundColor: gist.background }}
          >
            <div className="title-overlay">
              <div className="purchase-season-cta cta">
                {gist.cta}
              </div>
            </div>
          </div>
        </a>
      );
    } else {
      return (
        <div>
          <a
            className={`video-tray-item ${
              this.state.hoverOverflow ? "overflow" : ""
            }`}
            href={gist.permalink}
            ref={this.el}
            onClick={this.handleClick}
            onFocus={this.handleFocus}
            onMouseEnter={this.handleHover}
          >
            <div className="image-and-details">
              {this.metaData}
              <Badge item={item} thumbnailType={this.props.thumbnailType} />
              {gist.contentType === "VIDEO" && (
                <div className="play-button site-color">
                  <i className="ion-ios-play" />
                </div>
              )}
              {isTrayGlow && <div className="shadow-box" style={this.trayHoverStyle}/>}
              <div className="image">
                <img
                  src={
                    this.props.clickNext || !this.props.lazyLoad
                      ? getThumbnailImage(this.props)
                      : getLowQualityImage(this.props)
                  }
                  alt={gist.title}
                  className="lazy"
                  data-src={getThumbnailImage(this.props)}
                />

                {gist.contentType === "VIDEO" && (
                  <div
                    className="queue-bar site-color"
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    {this.state.userData && (
                      <WatchlistBtn
                        isAdded={this.state.userData.isQueued}
                        remove={this.removeFromQueue}
                        add={this.addToQueue}
                      />
                    )}
                  </div>
                )}

              </div>

              {this.props.infoHover && (
                <div className="details">
                  <div className="title">
                    {gist.title}
                  </div>
                  {gist.year && gist.runtime && (
                    <div className="info">
                      {gist.year} | {Math.ceil(gist.runtime / 60)}mins
                    </div>
                  )}
                  {item.parentalRating && (
                    <div className="rated">
                      {item.parentalRating.replace("_", "")}
                    </div>
                  )}
                  {gist.primaryCategory && (
                    <div className="category">{gist.primaryCategory.title}</div>
                  )}

                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: gist.description || ""
                    }}
                  />
                  <div className="crew">
                    {filteredCreditBlocks &&
                      map(filteredCreditBlocks, (c, i) => (
                        <div key={i}>
                          <span className="role">{getLocalizedVal(this.props.data,'metadataMap',`${c.title}Label`)|| c.title}</span>
                          <span className="people">
                            {" "}
                            {map(c.credits, "title")
                              .slice(0, 3)
                              .join(", ")}
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              )}


              {gist.watchHistory !== undefined && gist.watchHistory.watchedPercentage > 0 ? (
                <progress
                  className="site-color"
                  value={gist.watchHistory.watchedPercentage}
                  max="100"
                />
              ) : (
                ""
              )}

                
            </div>
            <div className="title-container">
              <div className="title">
                {this.props.isEpisode && !this.props.noEpisodeNumber && (
                  <span className="episode-number">
                    {index}
                  </span>
                )}{" "}
                {ellipsifyByChar(this.showTitle(gist), 50 - index.toString().length)}
              </div>
              {this.props.sharing && (
                <div className="share">
                  <div
                    className="share-toggle__icon"
                    onClick={this.handleShareToggleClick}
                  >
                    <span className="small-rect" />
                    <span className="small-rect" />
                    <span className="small-rect" />
                  </div>
                </div>
              )}
            </div>
            {isEpisodePurchasable && (
              <div className="purchase-episode-cta cta">
                {getLocalizedVal(window.settings,'genericMessages', 'purchaseOverlayLabel')} {window.settings.internalName.includes('bingeflix') ? getLocalizedVal(window.settings,'genericMessages', 'programLabel') : getLocalizedVal(window.settings,'genericMessages', 'hoverEpisodeLabel')} 
              </div>
            )}
            {isBundlePurchasable && (
              <div className="purchase-episode-cta cta" onClick={this.handleBundleClick}>
                {getLocalizedVal(window.settings,'genericMessages', 'purchaseOverlayLabel')} 
              </div>
            )}
          </a>
        </div>
      );
    }
  }
}

export default TrayItem;
